import React from "react";
import * as S from "./Cards.styes";
import AppVendas from "../../assets/images/appVendas.png";
import Solicitacao from "../../assets/images/computador.png";

export const CardsVenda = () => {
  return (
    <S.Cards>
      <S.Card>
        <a
          href="https://appcca.caixaconsorcio.com.br"
          target="_blank"
          rel="noreferrer"
          referrerPolicy="origin"
        >
          <img src={AppVendas} alt="app vendas" />
        </a>
        <p>Download de App de Vendas CAIXA Consórcio</p>
      </S.Card>
      <S.Card>
        <a
          href="http://seguridade.redeparceira.caixa.gov.br"
          target="_blank"
          referrerPolicy="origin"
          rel="noreferrer"
        >
          <img src={Solicitacao} alt="vendas consorcio" />
        </a>
        <p>Acesso ao Sistema de Vendas Online (seguridade.redeparceira) </p>
      </S.Card>
    </S.Cards>
  );
};
